import React from 'react'
import VatPromptModalComponent from './vat-prompt-modal.component'
import lang from '@/lang'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openVatPromptModal = (params) => {
  const getComponent = () => (
    <VatPromptModalComponent
      title= {lang.vatPrompt.title}
      description= {lang.vatPrompt.description}
      okButtonLabel= {lang.vatPrompt.okButtonLabel}
      cancelButtonLabel= {lang.vatPrompt.cancelButtonLabel}
      {...params}
    />
  )

  renderElement(getComponent)
}

export default openVatPromptModal
